import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=7dd2288d&scoped=true"
import script from "./ReCaptcha.vue?vue&type=script&lang=js"
export * from "./ReCaptcha.vue?vue&type=script&lang=js"
import style0 from "./ReCaptcha.vue?vue&type=style&index=0&id=7dd2288d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd2288d",
  null
  
)

export default component.exports